import Core from "@/modules/core/service/Core";

export default  {
    props: {
        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        step: {
            required: true,
            type: Object,
        },

        index: {
            required: true,
            type    : Number
        },

        bus: {

        }
    },

    data: () => ({
        unit      : null,
        form      : false,
        freeze    : null,
        collective: false,
        prevStatus: null
    }),

    computed: {
        current () {
            if (!this.unit) {
                return null;
            }

            return this.data.collection.find (s => s.unit.id === this.unit.id);
        },
    },

    watch: {
        current () {
            this.initBase();
        }
    },

    methods: {
        initBase () {
            if (this.current) {
                this.prevStatus = this.current.status;
            }
        },

        _clipboardEntry () {
            if (!this.current) {
                return false;
            }

            return this.current.clipboardEntry;
        },

//        _stepUnits() {
//            console.log("step units ", Inc.step.units(this.data))
//            return Inc.step.units(this.data);
//        },

        /**
         * Status of the processing step has changed. Store the incident.
         */
        onStatusChanged (status) {
            this.setVisibility();

            if (this.prevStatus !== status) {
                if ((this.prevStatus.id === 6 && status.id !== 6) || (this.prevStatus.id === 205 && status.id !== 205)) {
                    Core.message.confirm(
                        this,
                        this.$t("repair.reset.confirm.query", [ this.prevStatus.name ]),
                        this.$t("repair.reset.confirm.text", [ status.name, this.prevStatus.name ]),
                        { width: this.prevStatus.id === 6 ? 570 : null},
                        (value) => {
                            if (value) {
                                this.current.status = status;
                                this.prevStatus = status;

                                this.validate().then (() => {
                                    this.$emit("save");
                                });
                            } else {
                                console.log("reset to", this.prevStatus)
                                this.$nextTick(() => {
                                    this.current.status = this.prevStatus;
                                    this.$emit("refresh");
                                })
                            }
                        })
                    return;
                }
            }

            this.current.status = status;
            this.prevStatus = status;

            this.validate().then (() => {
                this.$emit("save");
            });
        },

        onJournalFront () {
            this.$emit("journal");
        },

        /**
         * Default imolementation of setVisibility is empty.
         */
        setVisibility () {
        }
    }
}